/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './frequency.reducer';

export const FrequencyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const frequencyEntity = useAppSelector(state => state.frequency.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="frequencyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.frequency.detail.title">Frequency</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.frequency.id">Id</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.id}</dd>
          <dt>
            <span id="treatmentCycles">
              <Translate contentKey="tinyMedicRestApp.frequency.treatmentCycles">Treatment Cycles</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.treatmentCycles}</dd>
          <dt>
            <span id="cycleDuration">
              <Translate contentKey="tinyMedicRestApp.frequency.cycleDuration">Cycle Duration</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.cycleDuration}</dd>
          <dt>
            <span id="cycleDurationUnits">
              <Translate contentKey="tinyMedicRestApp.frequency.cycleDurationUnits">Cycle Duration Units</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.cycleDurationUnits}</dd>
          <dt>
            <span id="intervalBetweenCycles">
              <Translate contentKey="tinyMedicRestApp.frequency.intervalBetweenCycles">Interval Between Cycles</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.intervalBetweenCycles}</dd>
          <dt>
            <span id="intervalUnits">
              <Translate contentKey="tinyMedicRestApp.frequency.intervalUnits">Interval Units</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.intervalUnits}</dd>
          <dt>
            <span id="totalTreatmentDuration">
              <Translate contentKey="tinyMedicRestApp.frequency.totalTreatmentDuration">Total Treatment Duration</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.totalTreatmentDuration}</dd>
          <dt>
            <span id="totalTreatmentUnits">
              <Translate contentKey="tinyMedicRestApp.frequency.totalTreatmentUnits">Total Treatment Units</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.totalTreatmentUnits}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.frequency.active">Active</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.frequency.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.frequency.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.frequency.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.frequency.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{frequencyEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/frequency" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/frequency/${frequencyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FrequencyDetail;
